import { Text, colors } from '@a0/quantum-web';
import * as S from './styled';
import dictionary from '../../../dictionary';
import { GETSTARTED } from '../../../constants';

const section = dictionary[GETSTARTED][0];

const GetStarted = () => (
  <S.Wrapper>
    <S.Title>{section.title}</S.Title>
    <S.LinksWrapper>
      {section.links.map((link) => {
        const Icon = link.icon;
        return (
          <S.Link href={link.url} key={link.title} target="_blank">
            <Icon />
            <Text
              type="Paragraph"
              size="xsmall"
              styleOverrides={{
                'text-decoration': 'none',
                'font-weight': '500',
                margin: 0,
                color: colors.neutral_n20,
                'grid-area': 'title',
              }}
            >
              {link.title}
            </Text>
            <Text
              type="Paragraph"
              size="xsmall"
              styleOverrides={{
                'text-decoration': 'none',
                margin: 0,
                color: colors.neutral_n60,
                'grid-area': 'description',
                transition: 'all 0.2s ease',
              }}
            >
              {link.description}
            </Text>
          </S.Link>
        );
      })}
    </S.LinksWrapper>
  </S.Wrapper>
);

export default GetStarted;
